export enum PlayerPermissionType
{
    AllowNewsletter,
    AllowSalesMaterial,
    AllowWinNotification,
    AllowWinSmsNotification
}
